import { useMemo, useRef } from "react";
import configs from "config";
import Crypto from 'crypto-js';
import { useIntercom } from "react-use-intercom";
import ls from "utils/secureStorage";
import { randomFixedInteger } from "utils";

interface IGenerateHash {
  plainText: string;
  secretKey: string;
}

function generateHash({ plainText, secretKey }: IGenerateHash) {
  return String(Crypto?.HmacSHA256(plainText, secretKey));
}

export function useSupport() {
  const isReady = useRef(false);
  const { boot, show } = useIntercom();

  const userEmail = ls.get('email');
  const email = useMemo(() => {
    const randomValue = ls.get(configs.ASSIGNED_INTERCOM_KEY);

    if (!randomValue) {
      const timestamp = new Date().getTime();

      const newValue = Math.floor(randomFixedInteger(12));

      ls.set(configs.ASSIGNED_INTERCOM_KEY, `${newValue}-${timestamp}`);
    }

    return userEmail ? userEmail : `support${randomValue}@bitmama.io`;
  }, [userEmail,]);

  const bootConfig = {
    email,
    utmSource: 'web'
  };

  if (configs.INTERCOM_SECRET && String(configs.INTERCOM_SECRET).length > 0) {
    try {
      const userHash = generateHash({
        plainText: email || "",
        secretKey: configs.INTERCOM_SECRET,
      });
      Object.assign(bootConfig, { userHash });
      if (userHash) isReady.current = true;
    } catch (err) {
      console.warn({ err });
    }
  }

  const bootWithProps = () => {
    let attempts = 0;
    while (!isReady.current && attempts++ < 2000) {
      console.warn("loading intercom...", attempts);
    }
    return boot(bootConfig);
  };

  return { bootWithProps, boot, show };
}
